import React from "react";
import AnimTimeLine from "../components/AnimTimeLine";
import SEO from "../components/SEO";

function Main() {
  const [isPortrait, setIsPortrait] = React.useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  React.useEffect(() => {
    const mql = window.matchMedia("(orientation: portrait)");
    const onChange = (e) => {
      setIsPortrait(e.matches);
    };

    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return (
    <>
      <SEO
        title="Emerging Evidence"
        description="Emerging Evidence Consulting. Combating Anachronisms in a post LLM era. Expert AI and data engineering solutions."
        path="/"
      />
      <div style={{ overflowX: "hidden" }}>
        <AnimTimeLine />
        {/* {isPortrait ? <AnimTimeLineV /> : <AnimTimeLine />} */}
      </div>
    </>
  );
}

export default Main;
